import * as React from "react";
import { Button, Card, CardActions, CardContent, CssBaseline, Grid, Typography, Container } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

import { ButtonProps } from "@mui/material/Button"; // Import ButtonProps type

// Define interface for blog items
interface IBlogItem {
    imgurl: string;
    title: string;
    description: string;
    buttonText: string;
    buttonVariant: ButtonProps['variant']; // Use specific Button variant type
    href: string; // Remove optional marker since we want this required
}

const blogs: IBlogItem[] = [ // Apply the interface type
    {
        imgurl: "/blog/blog1.png",
        title: "Quick Delivery",
        description: "Lightning-fast service, delivering your favorite meals promptly to your door.",
        buttonText: "see more",
        buttonVariant: "outlined",
        href: "https://www.facebook.com/hatbazaar" // Example href
    },
    {
        imgurl: "/blog/blog2.png",
        title: "A Good Auto Responder",
        description: "Fresh, top-quality ingredients prepared with meticulous hygiene for your well-being.",
        buttonText: "view ofer",
        buttonVariant: "outlined",
        href: "https://www.facebook.com/hatbazaar" // Example href
    },
    {
        imgurl: "/blog/blog3.png",
        title: "Home Delivery",
        description: "Enjoy unbeatable discounts on local shop delights, making dining delightful and affordable.",
        buttonText: "read more",
        buttonVariant: "outlined",
        href: "https://www.facebook.com/hatbazaar" // Example href
    },
];

const Blog = () => {
    return (
        <React.Fragment>
            <CssBaseline />
            <Container
                disableGutters
                maxWidth="md"
                component="main"
                sx={{ pt: 8, pb: 6 }}
            >
                <Typography
                    component="h6"
                    variant="h4"
                    align="center"
                    color="text.primary"
                    gutterBottom
                >
                    What We Do ! Why You Chose Us!
                </Typography>
                <div style={{
                    textAlign: "justify"
                }}>
                    <Typography
                        variant="h6"

                        color="text.secondary"
                        component="p"
                        align="center"
                    >
                        We delivery all kinds of food available near to you in hygienic way and on time.
                    </Typography>
                </div>

            </Container>
            {/* End hero unit */}
            <Container maxWidth="lg" component="main" style={{ justifyContent: "center", textAlign: "center" }}>
                <Grid container spacing={5} alignItems="flex-end">
                    {blogs.map((blog) => (
                        // Enterprise card is full width at sm breakpoint
                        <Grid mb={3}
                            item
                            key={blog.title}
                            xs={12}
                            sm={6}
                            md={4}
                        >
                            <Card>
                                <CardContent>
                                    <img
                                        src={blog.imgurl}
                                        data-rimg-scale="1"
                                        height={220}
                                        width={250}
                                        alt={blog.title}
                                    />
                                    <Typography
                                        variant="button" display="block" gutterBottom
                                    >
                                        {blog.title}
                                    </Typography>
                                    <Typography
                                        component="p" // Change from 'li' to 'p' for semantic correctness
                                        variant="subtitle1"
                                        align="center"
                                    >
                                        {blog.description}
                                    </Typography>

                                </CardContent>

                                <CardActions style={{ justifyContent: "center", textAlign: "center" }}>
                                    {blog.href ? (
                                        <Button
                                            href={blog.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            endIcon={<ArrowRightAltIcon />}
                                            variant={blog.buttonVariant || 'contained'}
                                            color="primary"
                                        >
                                            {blog.buttonText}
                                        </Button>
                                    ) : (
                                        <Button
                                            variant={blog.buttonVariant || 'contained'}
                                            color="primary"
                                            endIcon={<ArrowRightAltIcon />}
                                            onClick={() => console.log('No href provided')}
                                        >
                                            {blog.buttonText}
                                        </Button>
                                    )}
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

            </Container>
        </React.Fragment>
    );
};

export default Blog;
